import Layout from "../../../../Components/Layout";
import Settings from "../../../../Components/EventMgt/CreateEvent/Settings/Settings";
import CreateEventFormTab from "../../../../Components/EventMgt/CreateEvent/CreateEventFormTab";
const SettingsPage = () => {
    return <Layout
        BackAction="/organizer/MyEvents"
        Heading="Settings"
        TitleClassName="event-create-title"
        HeadClassName="event-page-head event-create-head"
        CreateHead
        activeMenuId="create-event"
        ExtraclassName="event-create-panel"
    >
        <div className="eventCreationFrom">
            <CreateEventFormTab Id="settings" />
            <Settings />
        </div>
    </Layout>
}

export default SettingsPage